"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = require("react-redux");
var React = require("react");
var SavePropertiesAction_1 = require("@/pages/saveproperties/actions/SavePropertiesAction");
var Megafoot_1 = require("@/pages/common/components/Megafoot");
var ResultItemComponent_1 = require("@/pages/search/components/ResultItemComponent");
var ResultPagination_1 = require("@/pages/search/components/ResultPagination");
var Enquire_1 = require("@/pages/common/components/Enquire");
var SavesPage_1 = require("@/pages/common/components/SavesPage");
var Login_1 = require("@/pages/common/components/Login");
var mapStateToProps = function (state) { return (__assign(__assign({}, state.saveProperties), { currencyOptions: state.layout.currencies.options, symbol: state.layout.currencies.options.find(function (it) { return it.key === state.layout.currencies.currentCurrencyId; }).symbol, googleApi: state.layout.googleApi, lang: state.layout.language.languages.find(function (it) { return it.id === state.layout.language.current; }).code1, resultT: state.resultT })); };
var mapDispatchToProps = function (dispatch) { return ({
    setPage: function (n) { return dispatch(SavePropertiesAction_1.default.setPage(n)); },
    onFavClicked: function (item) { return dispatch(SavePropertiesAction_1.default.onFavClicked(item)); },
    onItemClicked: function (item) { return dispatch(SavePropertiesAction_1.default.onItemClicked(item)); },
    onEnquireClicked: function (item) { return dispatch(SavePropertiesAction_1.default.onEnquireClicked(item)); },
}); };
var saveProperties = function (props) {
    var renderResultItem = function (props) { return function (it, index) {
        var symbol = it.currencyId >= 0 ? props.currencyOptions.find(function (it2) { return it2.key === it.currencyId; }).symbol : props.symbol;
        return (React.createElement(ResultItemComponent_1.default, { notAvailable: !it.available, item: it, key: index, t: props.resultT, filterType: it.type, symbol: symbol, googleApi: props.googleApi, lang: props.lang, onEnquireClicked: props.onEnquireClicked, onFavClicked: props.onFavClicked, onItemClicked: props.onItemClicked }));
    }; };
    var renderEmpty = function (props) {
        return (React.createElement("div", { className: "c-noresult" },
            React.createElement("div", { className: "c-noresult__icon" },
                React.createElement("img", { src: "/res/img/404.jpg" })),
            React.createElement("div", { className: "c-noresult__body" },
                React.createElement("div", { className: "c-noresult__title" }, props.t.emptyTitle),
                React.createElement("div", { className: "c-noresult__caption" }, props.t.emptyCaption))));
    };
    var renderPager = function (props) {
        return ResultPagination_1.renderPagination(props.currentPage, props.totalPage, props.setPage, props.resultT, '');
    };
    return (React.createElement(SavesPage_1.default, null,
        React.createElement("div", { className: "l-pad-content", style: { minHeight: '50vh' } },
            React.createElement("div", { className: "c-page-header c-page-header--center-mobile" },
                React.createElement("div", { className: "c-page-header__body" },
                    React.createElement("div", { className: "c-page-header__title" }, props.t.title),
                    React.createElement("div", { className: "c-page-header__caption" }, props.t.caption))),
            React.createElement("div", { className: "c-result__results " + (props.isLoading ? 'c-result__results--loading' : '') },
                React.createElement("div", { className: "c-result__result-page" },
                    React.createElement("div", { className: "c-result", "custom-sliderinit": "0" },
                        props.properties && props.properties.length
                            ? (React.createElement("div", { className: "c-result__items c-result__items--nopad" }, props.properties.map(renderResultItem(props))))
                            : renderEmpty(props),
                        props.totalPage > 0 ? renderPager(props) : null)),
                React.createElement("div", { className: "c-result__loading" },
                    React.createElement("div", { className: "c-result__loading-wrap" },
                        React.createElement("span", { className: "fal fa-redo fa-spin" }),
                        React.createElement("div", { className: "c-result__loading-text" }, "Loading"))))),
        React.createElement(Megafoot_1.default, null),
        React.createElement(Enquire_1.default, null),
        React.createElement(Login_1.default, null)));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(saveProperties);
